/**
 *  For dynamic table height, we iterate trough array of elements whose height we need to subtract
 *  from 100vh, this way we don't care if elements change height on lower resolutions
 */

/**
 * Function that calculates height of table inner content which will be available for scrolling
 * - It loops through fixed parts of AntDesign Table component - table header & footer and additional elements
 * - It sums up all of the heights of the fixed elements
 * @param additionalFixedElements List of divs that take height space as well and should be substracted from the scroll space height as well
 * @returns
 */
export const getTableScrollHeight = (
  additionalFixedElements: string[] = []
) => {
  const headerHeight = 64;
  let takenHeightSum = 64; // Initial value is set to pagination height
  const fixedElements = [
    ...additionalFixedElements,
    ".ant-table-thead",
    ".ant-table-footer",
  ];

  fixedElements.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((element) => {
      if (element) {
        const styles = window.getComputedStyle(element);

        // The clientHeight property returns the element height, including padding, but not the border, scrollbar or margin
        const verticalMarginSpace =
          parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

        const verticalPaddingSpace =
          parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

        const verticalBorderSpace =
          parseFloat(styles.borderBottomWidth) +
          parseFloat(styles.borderTopWidth);

        takenHeightSum +=
          element.clientHeight +
          verticalMarginSpace +
          verticalBorderSpace +
          verticalPaddingSpace +
          parseFloat(styles.strokeWidth);
      }
    });
  });

  return takenHeightSum + headerHeight + 32;
};

/**
 * Sets height to ant-table-container, intended to be used with useScreenResize hook to automatically set table height on screen resize
 * @param scrollConfig List of divs that take height space as well and should be substracted from the scroll space height as well
 * @param overrideHeight Specific height of a table
 */
export const setTableHeight = (
  scrollConfig?: string[],
  overrideHeight?: string
) => {
  const takenHeight = getTableScrollHeight(scrollConfig);
  const tableBody = document.querySelector(".ant-table-body");

  if (tableBody) {
    if (overrideHeight)
      return (tableBody.className = `ant-table-body tableHeightVH-${overrideHeight}`);
    if (takenHeight)
      return (tableBody.className = `ant-table-body tableHeight-${takenHeight}`);
  }
};
